module.exports = __webpack_public_path__ + "img/lezart palyazatok_gomb_aktiv.040937aa.png";